const d3 = require('d3')
const { addPdfCoverTitle } = require('../pdfPage')



function renderBanner(redrawFullRadar) {
  const documentTitle = document.title[0].toUpperCase() + document.title.slice(1)

  // World Kinect (WK) - truncate subheading
  const shortSubheading = documentTitle.split(' ').pop()

  d3.select('.hero-banner__subtitle-text').text(shortSubheading)

  // Navigation menu is now hardcoded in index.html

  d3.select('.hero-banner__title-text').on('click', redrawFullRadar)
  addPdfCoverTitle(documentTitle)
}

module.exports = {
  renderBanner,
}
